// @flow
import styled from "styled-components"

export const DateTileWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  width: 7rem;
  flex-shrink: 0;
`



// WEBPACK FOOTER //
// ./src/components/ReservationList/ReservationTile/DateTile/styled.js